<template>
    <div class="bottm_page">
        <languages />
        <div class="help sever" @click="handleGoUrl('help')">
            <span>{{ $t('newHome.Help') }}</span>
        </div>
        <div class="online sever" @click="handleGoUrl()">
            <span> {{ $t('newHome.online') }}</span>
        </div>
    </div>

</template>

<script>
import languages from '../common/languages.vue'
export default {
    components:{ languages },
    data(){
        return {
        }
    },
    methods:{
        handleGoUrl(type){
            if(type == 'help') return this.$router.push({ path:'/helpCenter/startUse',query:{ id:1}})
            else window.LiveChatWidget ? window.LiveChatWidget.call('maximize') : ''
        }
    }
}
</script>

<style lang="scss" scoped>
.bottm_page{
    display:flex;
    .sever{
        cursor: pointer;
        font-family: Roboto-Bold;
        font-size: 14px;
        font-weight: 550;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #ffffff;
        &::before{
            content:'';
            display:inline-block;
            overflow: hidden;
            width:26px;
            height:26px;
            margin-right:5px;
            vertical-align: middle;
        }
    }
    
}
</style>


// WEBPACK FOOTER //
// src/pages/build902/components/Header/serve.vue